interface Props {
    src:any
}

//default image for static template
export default function Image(props:Props) {
    return (
        <img className = "static-img"  src = {props.src} />
    )
}